var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"plan-form"},[_c('PlanEditForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }